import React from "react";
import useTranslationJobDashboard from "../useTranslationJobDashboard";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import useMutationJobAlertUpdate from "../mutate/useMutationJobAlertUpdate";
import Alert from "@material-ui/lab/Alert";
import Container from "react-bootstrap/Container";
import "./JobDashboardAlertsListItems.scss";
import useErrorModal from "../../common/modals/useErrorModal";
import useServerErrorFormatter from "../../common/modals/useServerErrorFormatter";
import TypeUtils from "../../../utils/TypeUtils";

export default function JobDashboardAlertsListItems(props) {
  const { items: alerts } = props;

  const { mutate, errors: errorsUpdateErrors } = useMutationJobAlertUpdate();

  const { t, loading: tLoading } = useTranslationJobDashboard();
  useShowLoader(tLoading, "JobDashboardAlertsListItems");

  const errorMsg = useServerErrorFormatter(errorsUpdateErrors);

  const { ErrorModal, show: showErrorModal } = useErrorModal(
    <>
      <p>{t("job-dashboard:job_dashboard_alert_update_error")}</p>
      {errorMsg}
    </>
  );

  const emptyMsg = t("job-dashboard:job_dashboard_empty_alerts_list_msg");

  const onClose = (id) => {
    const variables = {};
    variables["id"] = id;
    variables["status"] = "VIEWED";
    mutate({ variables }).catch((/*error*/) => {
      showErrorModal();
    });
  };

  return (
    <>
      {ErrorModal}
      <Container className="JobDashboardAlertsListItems spaced-children">
        {TypeUtils.arrayIsEmpty(alerts) && (
          <span className={"empty-message"}>{emptyMsg}</span>
        )}
        {alerts.map((alert, i) => (
          <Alert
            key={i}
            className="alert-col"
            variant="filled"
            severity={alert.alertType.toLowerCase()}
            onClose={() => {
              onClose(alert._id);
            }}
          >
            {alert.message}
          </Alert>
        ))}
      </Container>
    </>
  );
}
